import React from 'react';
import { personalInfoInitialValues, personalInfoValidationSchema } from 'constants/account-profile';
import { PersonalContactForm } from './PersonalContactForm';
import { Formik } from 'formik';
import { mockPersonalContact, mockUIConuntries } from 'pages/mockup/constant';
import { get_countries } from 'utils/countries';

const PersonalContactInfo = ({ width }) => {
  const countries = get_countries(mockUIConuntries);

  return (
    <Formik
      initialValues={personalInfoInitialValues(mockPersonalContact, { country: countries[0]?.value })}
      validationSchema={personalInfoValidationSchema}
      enableReinitialize
      onSubmit={async () => {}}
    >
      {(formikProp) => (
        <PersonalContactForm width={width} formikProp={formikProp} editProfileLoad={false} countries={countries} />
      )}
    </Formik>
  );
};
export default PersonalContactInfo;
